import React, { Fragment } from "react";
import {
  InstantSearch,
  Pagination,
  RefinementList,
  SearchBox,
  Configure,
} from "react-instantsearch/dom";
import {
  SectionFull,
  Heading,
  Hero,
  Sidebar,
  variables,
} from "@website2018/da-dobsonville";
import "react-instantsearch-theme-algolia/style.css";
import { connectMenu } from "react-instantsearch/connectors";
import qs from "qs";
import NoSSR from "../../components/Nav/NoSSR";
import { sanitarize } from "../../common/utils";
import Spacing from "../../components/Spacing/Spacing";
import SearchResults from "../../components/Newsroom/SearchResults";

const updateAfter = 700;
const createURL = (state) => `?${qs.stringify(state)}`;
const searchStateToUrl = (props, searchState) =>
  searchState ? `${props.location.pathname}${createURL(searchState)}` : "";

class SearchContainer extends React.Component {
  constructor(props) {
    super(props);

    const searchState = qs.parse(props.location.search.slice(1));
    this.state = { searchState };
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      const searchState = qs.parse(this.props.location.search.slice(1));
      this.setState({ searchState });
    }
  }

  onSearchStateChange = (searchState) => {
    clearTimeout(this.debouncedSetState);
    this.debouncedSetState = setTimeout(() => {
      this.props.history.push(
        searchStateToUrl(this.props, searchState),
        searchState
      );
    }, updateAfter);
    this.setState({ searchState });
  };

  clearSearch = () => {
    this.setState({ searchState: {} });
  };

  render() {
    const { spacing } = variables;
    const {
      site: {
        province: { slug },
      },
    } = this.props;

    return (
      <InstantSearch
        appId="6J2DNE3OT9"
        apiKey="252c455b15cdf890907eeb941b4c8c37"
        indexName={`wp_${slug.replace("-", "")}_searchable_posts`}
        searchState={this.state.searchState}
        onSearchStateChange={this.onSearchStateChange.bind(this)}
        createURL={createURL}
      >
        <Configure hitsPerPage={10} />
        {this.props.showTitle ? (
          <Hero
            title={
              this.state.searchState.query
                ? sanitarize(`Search for “${this.state.searchState.query}”`)
                : "Search"
            }
            small
          />
        ) : null}
        <SectionFull>
          <div className="col-lg-7 results__wrapper">
            <NoSSR>
              <SearchResults type={this.props.type || null} />
            </NoSSR>
            <Pagination showLast={true} />
          </div>
          <Sidebar>
            <Spacing bottom size={spacing.space2}>
              <SearchBox />
            </Spacing>
            {this.props.defaultRefinement ? (
              <VirtualMenu
                attributeName={this.props.defaultRefinement.attribute}
                defaultRefinement={this.props.defaultRefinement.value}
              />
            ) : null}
            {this.props.refinements ? (
              <Fragment>
                {this.props.refinements.map((r) => (
                  <Spacing bottom size={spacing.space2} key={r.attribute}>
                    <Heading
                      size={"tiny"}
                      weight={"bold"}
                      letterSpacing={"small"}
                      mb={"tiny"}
                      uppercase
                    >
                      {r.title}
                    </Heading>
                    <RefinementList
                      key={r.attribute}
                      attributeName={r.attribute}
                      {...r}
                    />
                  </Spacing>
                ))}
              </Fragment>
            ) : null}
            {this.props.renderWidgets ? this.props.renderWidgets() : null}
          </Sidebar>
        </SectionFull>
      </InstantSearch>
    );
  }
}

const VirtualMenu = connectMenu(() => null);

export const dateRegex =
  /^([0-9]{4})-([0-1][0-9])-([0-3][0-9])T([0-2][0-9]):([0-5][0-9]):([0-5][0-9])/;

export default SearchContainer;
